import InternalTableColumn from '@/ecm/models/internalTable/InternalTableColumn';

export default class InternalTableRowItem {
    constructor (column, value) {
        this.column = new InternalTableColumn();
        this.value = null;

        if (column) {
            this.column = new InternalTableColumn(column);
            this.value = value || null;
        }
    }

    toDto () {
        return {
            Column: this.column.toDto(),
            Value: this.value,
        };
    }
}
